import { Component } from '@angular/core';

interface IProgramCard {
  eyebrowKey: string;
  titleKey: string;
  descKey: string;
  icon: string;
}

@Component({
  selector: 'app-our-programs',
  templateUrl: './our-programs.component.html',
  styleUrl: './our-programs.component.scss',
  standalone: false,
})
export class OurProgramsComponent {
  readonly programs: IProgramCard[] = [
    {
      eyebrowKey: 'our_programs.program_1_eyebrow',
      titleKey: 'our_programs.program_1_title',
      descKey: 'our_programs.program_1_desc',
      icon: 'assets/images/svg-icons/program-icon-1.svg',
    },
    {
      eyebrowKey: 'our_programs.program_2_eyebrow',
      titleKey: 'our_programs.program_2_title',
      descKey: 'our_programs.program_2_desc',
      icon: 'assets/images/svg-icons/program-icon-2.svg',
    },
    {
      eyebrowKey: 'our_programs.program_3_eyebrow',
      titleKey: 'our_programs.program_3_title',
      descKey: 'our_programs.program_3_desc',
      icon: 'assets/images/svg-icons/program-icon-3.svg',
    },
  ];
}
